import { connect } from "react-redux";
import SpecialCollectionMetadataComponent from "./SpecialCollectionMetadata";
import { deleteSpecialCollection } from "../state/actions";

const mapStateToProps = (state) => ({
  error: state.specialCollectionDetails.error,
  specialCollectionDetails: state.specialCollectionDetails.data,
});

const mapDispatchToProps = (dispatch) => ({
  deleteSpecialCollection: (specialCollectionPid) =>
    dispatch(deleteSpecialCollection(specialCollectionPid)),
});

export const SpecialCollectionMetadata = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialCollectionMetadataComponent);
